import { MdCancel } from "react-icons/md";
import { BsPinAngleFill } from "react-icons/bs";
import { GoDotFill } from "react-icons/go";
import { noteHighlightStatuses } from "./AgencyDetailPageLogic";

export const NotesSectionContent = ({ records, getNoteKey, isNotePinned }) => {
  const sortedNotes = [...records].sort((a, b) => Number(isNotePinned(b)) - Number(isNotePinned(a)));

  return (
    <div className="adp-notes-view-body">
      {sortedNotes.map((record, index) => {
        const notePinned = isNotePinned(record);
        const rawText = record[0] || "";
        const matchedStatus = noteHighlightStatuses.find((status) =>
          rawText.substring(0, 50).startsWith(status)
        );

        return (
          <div className="adp-note-item" key={getNoteKey(record) || `note-${index}`}>
            <p className="adp-note-text">
              <GoDotFill className="adp-note-bullet" size={12} />
              <span className="adp-note-message">
                {matchedStatus ? (
                  <>
                    <span className="adp-status-highlight">{matchedStatus}</span>{" "}
                    {rawText.substring(matchedStatus.length).trim()}
                  </>
                ) : (
                  rawText
                )}
                {notePinned && (
                  <span className="adp-pinned-badge">
                    <BsPinAngleFill size={10} /> Pinned
                  </span>
                )}
              </span>
            </p>

            <div className="adp-note-meta-row">
              <p className="adp-note-meta">
                {record[1]} at {record[2]}
                {record[3] && <span className="adp-status-highlight">{record[3]}</span>}
              </p>
              <span className="adp-note-vin-inline">{record[6] || "NA"}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
};

const NotesModal = ({ isOpen, onClose, children }) => {
  if (!isOpen) return null;

  return (
    <div className="adp-section-modal-overlay" >
      <div className="adp-section-modal" >
        <div className="adp-section-modal-header">
          <span>Notes</span>
          <button className="adp-section-modal-close" type="button" onClick={onClose} aria-label="Close Notes">
            <MdCancel size={25} />
          </button>
        </div>
        <div className="adp-section-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default NotesModal;
